import { ProductScreenshot } from 'components/ProductScreenshot';
import InitialDark from "../../../../contents/images/tutorials/first-last-touch-attribution/initial-dark.png";
import InitialLight from "../../../../contents/images/tutorials/first-last-touch-attribution/initial-light.png";
import ReferrerDark from "../../../../contents/images/tutorials/first-last-touch-attribution/referrer-dark.png";
import ReferrerLight from "../../../../contents/images/tutorials/first-last-touch-attribution/referrer-light.png";
import PathDark from "../../../../contents/images/tutorials/first-last-touch-attribution/path-dark.png";
import PathLight from "../../../../contents/images/tutorials/first-last-touch-attribution/path-light.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  InitialDark,
  InitialLight,
  ReferrerDark,
  ReferrerLight,
  PathDark,
  PathLight,
  React
};